import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ApiCalling from "../../network/ApiCalling";
import Util from "../../Util";
import Loader from "../../components/common/Loader";
import Search from "../../assets/Icon/Search.svg";
import close from "../../assets/Icon/close.svg";
import UserSchoolsTable from "./UserSchoolsTable";

const UserSchoolsSection = ({
  selectedUserSchoolsIds,
  setSelectedUserSchoolsIds,
  changeSelectedMultipleStatus,
  fetchUserSchoolsTrigger,
}) => {
  const { t } = useTranslation();
  const getLanguage = Util.getSelectedLanguage();

  const [userSchools, setUserSchools] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchClick, setSearchClick] = useState("");
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [roleId, setRoleId] = useState(0);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const EnterHandler = (event) => {
    if (event.key === "Enter") {
      setCurrentPage(1);
      setSearchClick(search);
    }
  };

  const handlePreviousClick = () => {
    if (currentPage !== 1) {
      setCurrentPage((currentPage) => currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage !== totalPages) {
      setCurrentPage((currentPage) => currentPage + 1);
    }
  };

  const searchClicked = () => {
    if (search.length > 0) {
      setSearch("");
      setSearchClick("");
    } else {
      setCurrentPage(1);
      setSearchClick(search);
    }
  };

  const handleAllSelectedUserSchools = (e) => {
    if (e.target.checked) {
      setSelectedUserSchoolsIds(userSchools.map((item) => item.id));
    } else {
      setSelectedUserSchoolsIds([]);
    }
  };

  const userSchoolsChecked = (event) => {
    const id = Number(event.target.value);
    if (event.target.checked) {
      setSelectedUserSchoolsIds([...selectedUserSchoolsIds, id]);
    } else {
      const data = selectedUserSchoolsIds.filter((s) => s !== id);
      setSelectedUserSchoolsIds(data);
    }
  };

  useEffect(() => {
    console.log("getAllUsersInSchools useEffect");
    let mounted = true;

    const getAllUsersInSchools = () => {
      const data = {
        page_size: recordPerPage,
        page_number: currentPage,
        role_id: roleId,
        str_search: searchClick,
        order_by: sortBy,
        ascdesc: sortOrder ? "desc" : "asc",
      };
      setIsLoading(true);
      ApiCalling.apiCallBodyDataPost("users-school/all", data)
        .then((res) => {
          if (mounted) {
            setUserSchools(res.data?.data);
            setTotalPages(res.data?.totalPages);
            setTotal(res.data?.total);
            setTimeout(() => {
              setIsLoading(false);
            }, 500);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getAllUsersInSchools();

    return () => {
      mounted = false;
    };
  }, [
    currentPage,
    recordPerPage,
    roleId,
    searchClick,
    sortBy,
    sortOrder,
    fetchUserSchoolsTrigger,
  ]);

  return (
    <div>
      <div className="row">
        <div className="col-md-6 text-start">
          <h3>Manage users in schools</h3>
        </div>
        <div className={`col-md-6  ${getLanguage !== "ar" && "text-end"}`}>
          {selectedUserSchoolsIds.length > 0 ? (
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={() => changeSelectedMultipleStatus({ active: true })}
              >
                Change to active
              </button>
              <button
                onClick={() => changeSelectedMultipleStatus({ active: false })}
              >
                Change to inactive
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="table-div">
        <div className="d-flex gap-20 align-items-center table-sort-bar">
          <div className="custom-search-wrap">
            <div className="input-group">
              <input
                className="form-control search "
                placeholder={t("Search user by email or name")}
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onKeyPress={(e) => EnterHandler(e)}
              />
              <div className="input-group-prepend">
                <div className="search-icon">
                  <img
                    src={search.length > 0 ? close : Search}
                    className="svg-icon"
                    alt=""
                    onClick={searchClicked}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <Loader />
        ) : (
          <div className="row">
            <div className="col-lg-12">
              <div className="table-wrapper">
                <UserSchoolsTable
                  userSchools={userSchools}
                  selectedUserSchoolsIds={selectedUserSchoolsIds}
                  handleAllSelectedUserSchools={handleAllSelectedUserSchools}
                  userSchoolsChecked={userSchoolsChecked}
                  setSortBy={setSortBy}
                  setSortOrder={setSortOrder}
                />
              </div>
              {totalPages > 0 && (
                <div
                  className="row m-0 table-footer  border-top"
                  style={{ height: "72px" }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-2">
                      <div>{t("Students Per Page")}</div>
                      <select
                        style={{ width: "72px", cursor: "pointer" }}
                        className="select-dropdown custom-input"
                        value={recordPerPage}
                        onChange={(e) => {
                          setRecordPerPage(e.target.value);
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                    <div>
                      <Stack spacing={2} direction="row" alignItems="center">
                        <div
                          className={`link-button ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            handlePreviousClick();
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <KeyboardArrowLeftIcon />
                          <span className="basic-bold-text">
                            {t("Previous")}
                          </span>
                        </div>
                        <Pagination
                          count={totalPages}
                          page={currentPage}
                          onChange={(event, page) => {
                            setCurrentPage(page);
                          }}
                          size="small"
                          hideNextButton
                          hidePrevButton
                        />
                        <div
                          className={`link-button ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNextClick();
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <span className="basic-bold-text">{t("Next")}</span>
                          <KeyboardArrowRightIcon />
                        </div>
                      </Stack>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserSchoolsSection;
